import React, { useCallback } from "react";
import { useService } from "student-front-commons/src/hooks";
import { getAttachments } from "student-front-commons/src/services/attachmentRepositoryService";
import Async from "../../core/Async";
import Panel from "../../core/Panel";
import Tabs from "../../core/Tabs";
import AttachmentPreviewModal from "./AttachmentPreviewModal";
import ContentFileRepository from "./ContentFileRepository";

function ContentFileRepositoryListContainer() {
  const [attachments, setAttachments] = React.useState(null);
  const [filePreview, setFilePreview] = React.useState(null);

  const [isFetching] = useService(getAttachments, {
    autoStart: true,
    onData: (data) => {
      setAttachments(data);
    },
  });

  const handleOpenFilePreview = useCallback((file) => {
    setFilePreview(file);
  }, []);

  return (
    <Async fetching={isFetching} color="dark" size="sm">
      {attachments !== null && attachments.length > 0 ? (
        <Tabs
          tabs={attachments.map((attachment) => {
            return {
              label: attachment.title,
              component: (
                <Panel padding="none" key={attachment.id}>
                  <ContentFileRepository root={attachment} handleOpenFilePreview={handleOpenFilePreview} />
                </Panel>
              ),
            };
          })}
        />
      ) : null}
      <AttachmentPreviewModal
        attachment={filePreview}
        showModal={!!filePreview}
        onClose={() => {
          setFilePreview(null);
        }}
      />
    </Async>
  );
}

export default ContentFileRepositoryListContainer;
